import { emptyViewState, type GraphView, type GraphViewNode } from '@/types/graph-view'
import type { SourceSnippet } from '@/types/source-snippet'

export function snippetNodeId(id: string) {
  return `snippet:${id}`
}

export function snippetSelection(id: string): { id: string; row?: number } | null {
  const match = /^snippet:([^:]+)(?:(?::row:(\d+))?(?::(?:time|geo):\d+)?|:track:\d+:.+)$/.exec(id)
  return match ? { id: match[1], row: match[2] === undefined ? undefined : Number(match[2]) } : null
}

export function mapObjectSetId(id: string, entityIds: Record<string, string>) {
  const snippet = snippetSelection(id)
  return snippet ? snippetNodeId(snippet.id) : entityIds[id]
}

export function upsertSourceSnippet(view: GraphView | null, snippet: SourceSnippet): GraphView {
  const base = view ?? {
    meta: {
      source: 'assistant' as const,
      createdAt: new Date().toISOString(),
      caseId: snippet.snapshot.caseId,
    },
    nodes: [],
    edges: [],
    view: emptyViewState(),
  }
  const snippets = base.snippets ?? []
  return {
    ...base,
    snippets: snippets.some(item => item.id === snippet.id)
      ? snippets.map(item => (item.id === snippet.id ? snippet : item))
      : [...snippets, snippet],
  }
}

export function snippetGraphNodes(snippets: readonly SourceSnippet[]): GraphViewNode[] {
  return snippets.map(snippet => {
    const stamps = snippet.projection.times
      .flatMap(time => (time.end ? [time.start, time.end] : [time.start]))
      .sort()
    return {
      id: snippetNodeId(snippet.id),
      labels: ['SourceSnippet'],
      typeLabel: 'SourceSnippet',
      name: snippet.title,
      properties: {
        name: snippet.title,
        source_snippet_id: snippet.id,
        row_count: snippet.snapshot.result.rows.length,
        ...(stamps.length
          ? { _temporal_min: stamps[0], _temporal_max: stamps[stamps.length - 1] }
          : {}),
      },
    }
  })
}
